import React from "react";

export const NavBarContext = React.createContext({
  navTitle: "" as React.ReactNode,
  setNavTitle: (title: React.ReactNode) => {},
  setNavBarStyle: (style: string) => {},
  navBarStyle: "",
});
export const useNavBarTitle = (title: React.ReactNode) => {
  const { setNavTitle, navTitle } = React.useContext(NavBarContext);
  const [previousTitle, setPreviousTitle] =
    React.useState<React.ReactNode>(navTitle);

  React.useEffect(() => {
    setNavTitle(title);
    return () => {
      setNavTitle(previousTitle);
    };
  }, [title]);
};

export const useNavBarStyle = (style: string) => {
  const { setNavBarStyle, navBarStyle } = React.useContext(NavBarContext);

  React.useEffect(() => {
    const currentStyle = navBarStyle;
    setNavBarStyle(style);
    return () => {
      setNavBarStyle(currentStyle);
    };
  }, [style]);
};
